import useElementFit from '@onepercentio/one-ui/hooks/useElementFit'
import React, { useMemo } from 'react'

/**
 * Adds a list of elements that provide a padding to a justified list
 **/
export default function ContainerListPadding({
  howManyItemsByRow,
  howManyItemsShowing,
  widthBoundClass,
}: Pick<ReturnType<typeof useElementFit>, 'howManyItemsByRow'> & {
  howManyItemsShowing: number
  widthBoundClass: string
}) {
  return useMemo(() => {
    if (!howManyItemsByRow) return []
    const padSize =
      howManyItemsByRow - (howManyItemsShowing % howManyItemsByRow)
    return new Array(padSize)
      .fill(undefined)
      .map((_, i) => <span className={widthBoundClass} key={`pad-${i}`} />)
  }, [howManyItemsShowing, howManyItemsByRow])
}
